import { Component } from '@angular/core';

@Component({
  selector: 'app-what-is',
  templateUrl: './what-is.component.html',
  styleUrls: ['./what-is.component.scss'],
})
export class WhatIsComponent {
  checkPoints = [
    // 'what_is.main_card_2.point1',
    'what_is.main_card_2.point2',
    'what_is.main_card_2.point3',
    'what_is.main_card_2.point4',
    'what_is.main_card_2.point5',
  ]

  designCards = [
    {
      title: "what_is.design_title_1",
      content: "what_is.design_desc_1"
    },
    {
      title: "what_is.design_title_2",
      content: "what_is.design_desc_2"
    },
    {
      title: "what_is.design_title_3",
      content: "what_is.design_desc_3"
    }, {
      title: "what_is.design_title_4",
      content: "what_is.design_desc_4"
    }
  ]

  stats = [
    {
      symbol: '$', value: 1.17, decimals: 2, suffix: 'T',
      txt: 'what_is.reserve_base'
    },
    {
      symbol: '', value: 70, decimals: 0, suffix: '%',
      txt: 'what_is.tokenisation'
    },
    {
      symbol: '', value: 30, decimals: 0, suffix: '%',
      txt: 'what_is.monetisation'
    },
    {
      symbol: '$', value: 96.39, decimals: 2, suffix: 'B',
      txt: 'what_is.liquidity_engine'
    },
  ];
}
